import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import authAPI from "../../api/authAPI";
import styles from "./PasswordReset.module.css";

const PasswordResetRequest = () => {
  const { t } = useTranslation("common");
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.body.classList.add(styles.background);
    return () => document.body.classList.remove(styles.background);
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      await authAPI.requestPasswordReset(email);
      setIsSubmitted(true);
    } catch (err) {
      setError(t("auth.resetPassword.error"));
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main className={styles.container}>
      <h1 className={styles.title}>{t("auth.resetPassword.title")}</h1>

      {isSubmitted ? (
        <div className={styles.successBox}>
          <h2 className={styles.successTitle}>{t("auth.resetPassword.successTitle")}</h2>
          <p className={styles.successText}>
            {t("auth.resetPassword.successText")}
          </p>
          <p className={styles.successSubtext}>
            {t("auth.resetPassword.successSubtext")}
          </p>
          <a href="/" className={styles.button}>
            {t("auth.resetPassword.backToLogin")}
          </a>
        </div>
      ) : (
        <form className={styles.form} onSubmit={handleSubmit}>
          <p className={styles.description}>
            {t("auth.resetPassword.description")}
          </p>

          <div className={styles.inputGroup}>
            <label htmlFor="email">{t("auth.resetPassword.emailLabel")}</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isSubmitting}
              className={styles.input}
            />
          </div>

          {error && <div className={styles.error}>{error}</div>}

          <button
            type="submit"
            className={styles.button}
            disabled={isSubmitting}
          >
            {isSubmitting ? t("auth.resetPassword.sending") : t("auth.resetPassword.sendButton")}
          </button>

          <a href="/" className={styles.backLink}>
            {t("auth.resetPassword.backToLogin")}
          </a>
        </form>
      )}
    </main>
  );
};

export default PasswordResetRequest;
